import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { ArthauptgrpListView } from "./list-view/arthauptgrp.list-view";

export const arthauptgrpFieldOk: FieldOkConfig = {
  name: 'arthauptgrp',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{arthauptgrp}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: ArthauptgrpListView,
      sort: {
        properties: [
          {property: 'id', title: 'Erfassungszeitpunkt'},
          {property: 'arthauptgrpsprbezeichnung', title: 'Bezeichung'},
        ]
      }
    }
  }
  ]
};
export const arthauptgrpMultiselectFieldOk: FieldOkConfig = {
  name: 'arthauptgrp',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{arthauptgrp}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: ArthauptgrpListView,
      sort: {
        properties: [
          {property: 'id', title: 'Erfassungszeitpunkt'},
          {property: 'arthauptgrpsprbezeichnung', title: 'Bezeichung'},
        ]
      }
    }
  }
  ]
};

export const arthauptgrpQueryFieldOk: FieldOkConfig = {
  name: 'arthauptgrp',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{arthauptgrp}} - {{bezeichnung}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: ArthauptgrpListView,
      sort: {
        properties: [
          {property: 'id', title: 'Erfassungszeitpunkt'},
          {property: 'arthauptgrpsprbezeichnung', title: 'Bezeichung'},
        ]
      }
    }
  }
  ]
};
